import { useCallback } from 'react';
import type { MedianValue } from '../../lib/filters/median';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Median panel — single radius slider (0..3). Radius 0 is the
 *  identity, displayed in the slider as the leftmost position so
 *  the user can dial back to "no effect" without leaving the
 *  dialog. */
export function MedianPanel({ value, onChange }: AdjustmentPanelProps<MedianValue>) {
  const set = useCallback(
    (patch: Partial<MedianValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Radius"
        min={0}
        max={3}
        step={1}
        value={value.radius}
        onChange={(v) => set({ radius: v })}
      />
    </div>
  );
}
